import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ProfileType, UpdateProfileParam} from "./reducerTypes";
import {AppDispatch, AppThunk} from "./store";
import {isBrowser} from "../common/fns";

const initialState: ProfileType = (isBrowser() && window.Cypress && window.initialState?.profile) || {
  phonenumber: "",
  fullname: "",
  dob: "",
  gender: "",
  res_seq: "",
  ride_type: "",
  damagedCount: 0,
  bank_info_name: "",
  bank_info_bank_code: "",
  bank_info_account_number: "",
};

const profileSlice = createSlice({
  name: "profile", initialState, reducers: {
    updateProfile: (state, action: PayloadAction<UpdateProfileParam>) => {
      return {...state, ...action.payload};
    }, clearProfile: (state, action: PayloadAction) => {
      return initialState;
    },
  },
});

export const updateProfile = (data: UpdateProfileParam): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(profileSlice.actions.updateProfile(data));
};

export const clearProfile = (): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(profileSlice.actions.clearProfile());
};

export default profileSlice.reducer;
